import React, { Component } from "react";
import ItemList from '../itemList';
import {ItemDetails, Field} from '../itemDetails';
import ErrorMessage from "../errorMessage";
import GotService from '../../services/gotService';
import RowBlock from "../rowBlock/rowBlock";

class CharacterPage extends Component {
    gotService = new GotService();
    
    state = {
        selectedChar: 130,
        error: false
    }

    static defaultProps = {
        flag: 'character'
    }


    onItemSelected = (id) => {
        this.setState({
            selectedChar: id
        })
    }

    componentDidCatch() {
        console.log('error');
        this.setState({
            error: true
        })
    }

    render() {

        if (this.state.error) {
            return <ErrorMessage/>
        }

        const itemList = (
            <ItemList 
            onItemSelected={this.onItemSelected}
            getData={this.gotService.getAllCharacters}
            renderItem={({name, gender}) => `${name} (${gender})`}/>
        )

        const itemDetails = (
            <ItemDetails
             itemId={this.state.selectedChar}
             flag={this.props.flag}>
                <Field field='gender' label='Gender'/>
                <Field field='born' label='Born'/>
                <Field field='died' label='Died'/>
                <Field field='culture' label='Culture'/>
            </ItemDetails>
        )

        return(
            <RowBlock 
            left={itemList} 
            right={itemDetails}/>
        )
    }
}

export {CharacterPage};